@if (replyTarget) {
  <div class="reply-composer rounded-[6px] border border-neutral-n5 bg-white" (focusout)="onFocusOut($event)">
    <!-- 顶部引用条：仅引用具体消息（回复个人）时显示，回复全班不显示 -->
    @if (quote && isTargetStudent) {
      <div
        class="mx-2 mt-2 flex h-[28px] items-center gap-[8px] rounded-[6px] bg-neutral-n9 px-[12px] text-[12px] text-neutral-n3"
      >
        <fl-message-summary
          class="truncate flex-1"
          [summary]="{
            label: quote.label || '回复',
            firstName: replyTarget.firstName,
            content: replyTarget.content,
            tags: replyTarget.tags,
            messageType: replyTarget.messageType,
            mediaUrls: replyTarget.mediaUrls,
          }"
        ></fl-message-summary>
        <!-- 关闭回复器：仅回复具体对象时显示 -->
        <button
          type="button"
          aria-label="关闭回复"
          class="flex h-[20px] w-[20px] shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-[14px] text-neutral-n3 transition-colors hover:bg-neutral-n5 hover:text-neutral-n1"
          (click)="onCancel()"
        >
          <span nz-icon nzType="close" nzTheme="outline"></span>
        </button>
      </div>
    }

    <!-- 输入区：textarea 常驻唯一（避免单行/复合切换时销毁重建丢失光标），容器随布局切换 -->
    <div [class]="isSingleRow ? 'flex items-center  py-[6px] pr-[12px]' : ' pt-[6px]'">
      <textarea
        #composerInput
        [(ngModel)]="content"
        name="replyContent"
        rows="1"
        [placeholder]="displayPlaceholder"
        (focus)="isFocused = true"
        (input)="autoGrow()"
        (paste)="onPaste($event)"
        [class]="
          isSingleRow
            ? 'min-w-0 flex-1 resize-none self-center px-[12px] py-[8px]'
            : 'min-w-0 w-full resize-none px-[12px] py-[8px]'
        "
        class="resize-none border-0 bg-transparent text-[14px] leading-[1.6] outline-none"
      ></textarea>

      <!-- 单行同排：按钮组与文字同行靠右 -->
      @if (isSingleRow) {
        <div class="flex shrink-0 items-center gap-[8px]">
          @if (upload() !== false) {
            <button
              type="button"
              aria-label="图片"
              class="flex h-[28px] w-[28px] cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-neutral-n3 transition-colors hover:text-primary disabled:opacity-40"
              [disabled]="uploading"
              (click)="imagePicker.click()"
            >
              <lib-fl-icon name="icon-yuantu" size="16"></lib-fl-icon>
            </button>
            <input
              #imagePicker
              type="file"
              accept="image/*"
              multiple
              class="hidden"
              (change)="onPickImage($event.target.files, imagePicker)"
              (cancel)="$event.stopPropagation()"
            />
          }
          <button
            type="button"
            aria-label="发送"
            class="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed"
            [class]="canSend ? 'bg-primary text-white hover:opacity-85' : 'bg-neutral-n4 text-white'"
            [disabled]="!canSend"
            (click)="onSubmit()"
          >
            <lib-fl-icon name="icon-fasong" size="16"></lib-fl-icon>
          </button>
        </div>
      }
    </div>

    <!-- 复合布局专属：图片区 + 底部工具栏（给个人 / 多行 / 有图时） -->
    @if (!isSingleRow) {
      <!-- 已选附件：图片为带边框大缩略（删除钮浮右上角）；其余为文件胶囊（可删） -->
      @if (attachments.length > 0 || uploading) {
        <div class="flex flex-wrap gap-[8px] px-[12px] pt-[8px]">
          @for (att of attachments; track att.url; let i = $index) {
            @if (att.kind === 'image') {
              <div class="relative">
                <img
                  [nzSrc]="att.url"
                  alt=""
                  nz-image
                  class="size-[80px] rounded-[6px] border border-neutral-n5 object-cover"
                />
                <button
                  type="button"
                  aria-label="移除附件"
                  class="absolute -right-[6px] -top-[6px] flex h-[24px] w-[24px] cursor-pointer items-center justify-center rounded-full bg-neutral-n1 text-white transition-colors hover:bg-red-r3"
                  (click)="onRemoveAttachment(i)"
                >
                  <span nz-icon nzType="close" nzTheme="outline" class="text-[11px]"></span>
                </button>
              </div>
            } @else {
              <div class="relative flex items-center gap-[6px] rounded-[6px] bg-neutral-n7 px-[8px] py-[4px]">
                <span nz-icon nzType="paper-clip" nzTheme="outline" class="text-[14px] text-neutral-n2"></span>
                <span class="max-w-[120px] truncate text-[12px] text-neutral-n2">{{ att.name }}</span>
                <button
                  type="button"
                  aria-label="移除附件"
                  class="flex h-[16px] w-[16px] cursor-pointer items-center justify-center rounded-full bg-neutral-n4 text-neutral-n9 hover:bg-red-r3"
                  (click)="onRemoveAttachment(i)"
                >
                  <span nz-icon nzType="close" nzTheme="outline" class="text-[10px]"></span>
                </button>
              </div>
            }
          }
          @if (uploading) {
            <div class="flex items-center gap-[6px] text-[12px] text-neutral-n3">
              <span nz-icon nzTheme="outline" nzSpin nzType="loading"></span>
              上传中…
            </div>
          }
        </div>
      }

      <!-- 底部工具栏：宿主插槽（如「全班可见」）靠左 + 图片/发送靠右 -->
      <div class="flex items-center justify-between px-[12px] py-[6px]">
        <div class="flex items-center">
          <ng-content select="[toAll]"></ng-content>
        </div>
        <div class="flex items-center gap-[8px]">
          @if (upload() !== false) {
            <button
              type="button"
              aria-label="图片"
              class="flex h-[28px] w-[28px] shrink-0 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-neutral-n3 transition-colors hover:text-primary disabled:opacity-40"
              [disabled]="uploading"
              (click)="imagePicker.click()"
            >
              <lib-fl-icon name="icon-yuantu" size="16"></lib-fl-icon>
            </button>
            <input
              #imagePicker
              type="file"
              accept="image/*"
              multiple
              class="hidden"
              (change)="onPickImage($event.target.files, imagePicker)"
              (cancel)="$event.stopPropagation()"
            />
          }
          <button
            type="button"
            aria-label="发送"
            class="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed"
            [class]="canSend ? 'bg-primary text-white hover:opacity-85' : 'bg-neutral-n4 text-white'"
            [disabled]="!canSend"
            (click)="onSubmit()"
          >
            <lib-fl-icon name="icon-fasong" size="16"></lib-fl-icon>
          </button>
        </div>
      </div>
    }
  </div>
}
